import { nutrientColors } from "../nutrition/colors"

/// <reference path="..\nutrition\colors.ts" />

export enum PrescriptionType {
    Seed = 1,
    Fertiliser = 2,
    CropProtection = 3,
    Other = 4
}


export const prescriptionTypes = [

    {
        type: PrescriptionType.Seed,
        name: "Seed",
        icon: "reco-seeds",
        // Note: colors from the seed rate layer type
        style: {
            color: [
                155,
                89,
                21
            ],
            gradient: [
                [
                    255,
                    164,
                    72
                ],
                [
                    221,
                    137,
                    52
                ],
                [
                    188,
                    112,
                    37
                ],
                [
                    155,
                    89,
                    21
                ],
                [
                    121,
                    67,
                    11
                ],
                [
                    88,
                    46,
                    4
                ],
                [
                    55,
                    28,
                    0
                ]
            ]
        }
    },

    {
        type: PrescriptionType.Fertiliser,
        name: "Fertiliser",
        icon: "stock-fertiliser",
        style: {
            color: nutrientColors.P2O5.baseColor,
            gradient: convertGradient(nutrientColors.P2O5.gradient)
        }
    },

    {
        type: PrescriptionType.CropProtection,
        name: "Crop protection",
        icon: "sprayer",
        style: {
            color: nutrientColors.N.baseColor,
            gradient: convertGradient(nutrientColors.N.gradient)
        }
    },

    {
        type: PrescriptionType.Other,
        name: "Other",
        icon: "mmp",
        style: {
            color: nutrientColors.Lime.baseColor,
            gradient: convertGradient(nutrientColors.Lime.gradient)
        }
    }

]

function convertGradient<T extends { Colour: number[] }>(items: T[]) {
    return items.map(i => i.Colour)
}
